import React, { Component } from "react";
import "react-widgets/dist/css/react-widgets.css";
import { Col, Row, Form } from "react-bootstrap";
import { getByInnerBranchId } from "../../../../actions/CenterConfigurationActions";
import { connect } from "react-redux";
import { 
	GET_BY_INNER_BRANCH_ID_CENTER_CONFIGURATION,
	UPDATE_CENTER_CONFIGURATION,
	GET_ERRORS} from "../../../../actions/types";

class CenterConfigurationModalComponent extends Component {

	state = {
		centerData:              null,
		center_configuration_id: null,
		enable_best_price :      false,
		enable_offers :          false
	}

	constructor(props) {
		super(props);
		this.onPressEsc = this.onPressEsc.bind(this);
		this.handleChangeEnableOffers = this.handleChangeEnableOffers.bind(this);
		this.handleChangeEnableBestPrice = this.handleChangeEnableBestPrice.bind(this); // = this.handleChangeEnableOffers.bind(this);
		document.addEventListener('keydown', this.onPressEsc, false);
	}


	componentDidUpdate(prevProps) {
		if (this.state.centerData !== this.props.centerData) {
			this.setState({
				centerData: this.props.centerData
			});

			if(this.props.centerData != null){
				this.props.getByInnerBranchId(this.props.centerData.innerBranchId);
			}
		}
		else if (this.props.actionType === GET_BY_INNER_BRANCH_ID_CENTER_CONFIGURATION && 
			this.state.center_configuration_id !== this.props.centerConfiguration._id) {

			this.setState({
				center_configuration_id: this.props.centerConfiguration._id,
				enable_best_price:       this.props.centerConfiguration.enable_best_price,
				enable_offers:           this.props.centerConfiguration.enable_offers
			});
		}
	}

	onPressEsc(event) {
		if (event.keyCode === 27) {
			this.onPressCancel();
		}
	}

	clearData() {
		this.setState({
			center_configuration_id: null,
			enable_best_price:       false,
			enable_offers:           false,
		});
	}

	async preparateUpdate() {

		const centerConfiguration = {
			id:                this.state.center_configuration_id,
			enable_best_price: this.state.enable_best_price,
			enable_offers:     this.state.enable_offers
		};

		this.props.handleUpdate(centerConfiguration);
	}

	onPressCancel() {

		this.setState(
			{
				centerConfiguration : {
					enable_best_price: false,
					enable_offers:     false
				}
			},
			() => {
				this.props.handleCancel();
			}
		);
	}

	handleChangeEnableOffers(evt) {
		this.setState({
			enable_offers: evt.target.checked
		});
	}

	handleChangeEnableBestPrice(evt) {
		this.setState({
			enable_best_price: evt.target.checked
		});
	}

	render() {
		
		const title = "CONFIGURACIÓN DE CENTRO";

		return (
			<div
				className={
					this.props.isVisible ? "modal display-block" : "modal display-none"
				}
			>
				<div className="modal-center-main">
	
						<div className="auth-group">
							<center>{title}</center>
							<div className="auth-label"></div>
							<div className="auth-label"></div>
							<br></br>
							<Row>
								<Col xs={12} md={12} sm={12} lg={12}>
									<Form>

										<Form.Check
										 	onChange={this.handleChangeEnableBestPrice}
											checked={this.state.enable_best_price}
											type={"checkbox"}
											id={"check-enable-offers"}
											label={"Habilitar mejor precio (Se mostrara mejor precio, tomando en cuenta ofertas y precio MB de la lista configurada en su sucursal)."}
										/>
										<Form.Check
										 	onChange={this.handleChangeEnableOffers}
											checked={this.state.enable_offers}
											type={"checkbox"}
											id={"check-enable-offers"}
											label={"Mostrar sección de ofertas (Las secciones de ofertas muestran resultados)."}
										/>
									</Form>
								</Col>
							</Row>

							<br></br>
							<br></br>
							<div className="modal-activity-section">
								<button disabled={!this.state.center_configuration_id} className="modal-buttonOK" onClick={this.preparateUpdate.bind(this)}>
									GUARDAR
								</button>
						
								{
									<button
										className="modal-buttonNo"
										onClick={this.onPressCancel.bind(this)}
									>
										CERRAR
									</button>
								}
							</div>
						</div>
	
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	actionType: state.center_configuration_reducer.actionType,
	centerConfiguration: state.center_configuration_reducer.centerConfiguration,
	error: state.center_configuration_reducer.error,
});

export default connect(mapStateToProps, 
	{

		getByInnerBranchId
	
	}
)(CenterConfigurationModalComponent);
